<template>
  <button :class="classStyle" v-on="$listeners">
    <template v-if="loading">
      {{ loadingText }}
      <spinner />
    </template>
    <template v-else>
      {{ label }}
      <!-- @slot button content -->
      <slot />
    </template>
  </button>
</template>

<script>
import Spinner from "@/components/spinner/Spinner.vue";

export default {
  name: "VButton",
  components: { Spinner },
  props: {
    label: {
      type: String,
      default: null,
    },
    block: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    /** whether state is loading or not */
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "",
    },
    /** whether use full width */
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classStyle() {
      const { block, color, fullWidth, loading } = this;
      return [
        "v-button",
        color ? `v-button--${color}` : null,
        {
          "v-button--block": block,
          "v-button--full-width": fullWidth,
          "v-button--loading": loading,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.v-button {
  padding: 12px 18px;
  background: #444;
  border: 0;
  text-transform: uppercase;
  color: #fff;
  font-size: 13px;
  // border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
  height: 44px;
  line-height: 24px;
}

.v-button--block {
  display: block;
  width: 100%;
  text-align: center;
}

.v-button--gray {
  background-color: #f2f2f6;
  color: #666;
  border-color: #f2f2f6;
}

.v-button--full-width {
  width: 100%;
}

.v-button--loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-button:hover {
  opacity: 0.9;
}
</style>
